import React from "react";
import { toast, ToastContainer } from "react-toastify";
import { FiCheck, FiX, FiInfo, FiAlertTriangle } from "react-icons/fi";
import { HiSparkles } from "react-icons/hi2";

// Dedicated container ID so client toasts never collide with admin's default.
const CONTAINER_ID = "client-toast";

const baseOptions = {
    containerId: CONTAINER_ID,
    position: "bottom-center",
    autoClose: 2800,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    icon: false,
    closeButton: false,
};

const ToastBody = ({ icon, iconBg, iconColor, title, message }) => (
    <div className='flex items-center gap-2.5 min-w-0'>
        <div
            className='flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center'
            style={{
                background: iconBg,
                boxShadow: "0 4px 12px -2px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.25)",
            }}
        >
            <span style={{ color: iconColor, fontSize: 14, display: "inline-flex" }}>
                {icon}
            </span>
        </div>
        <div className='min-w-0 leading-tight'>
            {title && (
                <p className='text-white text-[11px] font-bold uppercase tracking-wider mb-0.5'>
                    {title}
                </p>
            )}
            <p className='text-white/85 text-sm font-medium break-words'>
                {message}
            </p>
        </div>
    </div>
);

export const clientToast = {
    success: (message, options = {}) =>
        toast(
            <ToastBody
                icon={<FiCheck />}
                iconBg='linear-gradient(135deg, #22c55e, #16a34a)'
                iconColor='#fff'
                title='Success'
                message={message}
            />,
            { ...baseOptions, ...options, className: "client-toast client-toast--success" }
        ),
    error: (message, options = {}) =>
        toast(
            <ToastBody
                icon={<FiX />}
                iconBg='linear-gradient(135deg, #ef4444, #dc2626)'
                iconColor='#fff'
                title='Error'
                message={message}
            />,
            { ...baseOptions, ...options, className: "client-toast client-toast--error" }
        ),
    info: (message, options = {}) =>
        toast(
            <ToastBody
                icon={<FiInfo />}
                iconBg='linear-gradient(135deg, #7F00FF, #FF8AFF)'
                iconColor='#fff'
                title='Info'
                message={message}
            />,
            { ...baseOptions, ...options, className: "client-toast client-toast--info" }
        ),
    warning: (message, options = {}) =>
        toast(
            <ToastBody
                icon={<FiAlertTriangle />}
                iconBg='linear-gradient(135deg, #FCFA02, #f59e0b)'
                iconColor='#121212'
                title='Heads up'
                message={message}
            />,
            { ...baseOptions, ...options, className: "client-toast client-toast--warning" }
        ),
    sparkle: (message, options = {}) =>
        toast(
            <ToastBody
                icon={<HiSparkles />}
                iconBg='linear-gradient(135deg, #FCFA02, #FF8AFF, #7F00FF)'
                iconColor='#fff'
                title='PicPromptify'
                message={message}
            />,
            { ...baseOptions, ...options, className: "client-toast client-toast--sparkle" }
        ),
};

export const ClientToastContainer = () => (
    <ToastContainer
        containerId={CONTAINER_ID}
        position='bottom-center'
        autoClose={2800}
        hideProgressBar
        closeOnClick
        pauseOnHover
        draggable
        newestOnTop
        limit={3}
        theme='dark'
    />
);

export default clientToast;
